export const PAYMENT_CODE_AUTHORISED = "Authorised";
export const PAYMENT_CODE_REDIRECT = "RedirectShopper";
export const PAYMENT_CODE_CANCELLED = "Cancelled";
export const PAYMENT_CODE_REFUSED = "Refused";